import { service } from ".";

export default {
  getAll: () => service.get("/messages"),
  getOne: (id) => service.get(`/messages/${id}`),
  getAllPaginate: (query) => service.get(`/messages/paginate?${query}`),
  create: (data) => service.post("/messages", data),
  update: (id, data) => service.put(`/messages/${id}`, data),
  achive: (id) => service.put(`/messages/arxiv/${id}`),
  delete: (id) => service.delete(`/messages/${id}`),
};
